import { Box, CssBaseline, Divider, MenuItem } from "@mui/material";
import {
  AccountButton,
  AuthProvider,
  Navbar,
  type OidcUser,
} from "@ssf/auth-components";
import {
  AppContainer,
  AppWrapper,
  Footer,
  Page,
  queryClient,
  s4Theme,
} from "@ssf/components";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Header } from "./components/Header";
import { Router } from "./components/index.js";
import { generatePath, i18next } from "./lib/index.js";

const CLUB_WEB_URL = process.env.CLUB_WEB_URL;
if (!CLUB_WEB_URL) {
  throw new Error("env `CLUB_WEB_URL` is not set");
}

const SIGNIN_REDIRECT_ARGS = { extraQueryParams: { createAccount: true } };
const onUser = (user: OidcUser | null | undefined) =>
  setMemdbAuthorization(user?.access_token);

export const App = () => {
  const { t } = useTranslation("Header");

  return (
    <AppWrapper env={import.meta.env} theme={s4Theme} i18n={i18next}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider signinRedirectArgs={SIGNIN_REDIRECT_ARGS} onUser={onUser}>
          <Page>
            <Navbar renderHeader={(props) => <Header {...props} />}>
              <AccountButton>
                {({ user, onClose }) => (
                  <Box>
                    <MenuItem
                      onClick={onClose}
                      component={Link}
                      to={generatePath("myPage", {
                        memberId: user.profile.sub,
                      })}
                    >
                      {t("myPage")}
                    </MenuItem>
                    <Divider />
                  </Box>
                )}
              </AccountButton>
            </Navbar>
            <AppContainer>
              <Router />
            </AppContainer>
            <Footer />
          </Page>
        </AuthProvider>
      </QueryClientProvider>
    </AppWrapper>
  );
};
